import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=6335f038&scoped=true&%23title=true&"
import script from "./Control.vue?vue&type=script&lang=js&"
export * from "./Control.vue?vue&type=script&lang=js&"
import style0 from "./Control.vue?vue&type=style&index=0&id=6335f038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335f038",
  null
  
)

export default component.exports